














import { Component, Vue } from 'vue-property-decorator';

import BrokerQuotesWidget from '@/components/Home/InsureCareTeams/BrokerQuotesWidget.vue';
import BrokerClientsWidget from '@/components/Home/InsureCareTeams/BrokerClientsWidget.vue';
import AccountWidget from '@/components/Home/InsureCareTeams/AccountWidget.vue';

@Component({
     name: 'ICTSideBar',
     components: {
          AccountWidget,
          BrokerQuotesWidget,
          BrokerClientsWidget,
     },
})
export default class ICTSideBar extends Vue {}
